
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Edit, Eye, ListChecks, Users, AlertTriangle } from "lucide-react"; // Added icons

interface JobActionsProps {
  jobId: string;
}

export const JobActions = ({ jobId }: JobActionsProps) => {
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Actions</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Job Options</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate(`/jobs/${jobId}`)}>
          <Eye className="mr-2 h-4 w-4" />
          View Details
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate(`/jobs/${jobId}#overview-edit`)}> 
          {/* Assuming overview-edit hash can trigger edit mode on overview */}
          <Edit className="mr-2 h-4 w-4" />
          Edit Job Details
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate(`/jobs/${jobId}#actions`)}>
          <ListChecks className="mr-2 h-4 w-4" />
          Manage Actions
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate(`/jobs/${jobId}#matching-candidates`)}>
          <Users className="mr-2 h-4 w-4" />
          View Candidates
        </DropdownMenuItem>
        {/* <DropdownMenuItem>Change Status</DropdownMenuItem> */}
        <DropdownMenuSeparator />
        <DropdownMenuItem className="text-destructive" onClick={() => alert(`Delete job ${jobId} - (not implemented)`)}>
          <AlertTriangle className="mr-2 h-4 w-4" />
          Delete (Coming Soon)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
